import { render, staticRenderFns } from "./DataArea.vue?vue&type=template&id=b84aeca0&scoped=true"
import script from "./DataArea.vue?vue&type=script&lang=js"
export * from "./DataArea.vue?vue&type=script&lang=js"
import style0 from "./DataArea.vue?vue&type=style&index=0&id=b84aeca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84aeca0",
  null
  
)

export default component.exports